import React, {useState, useEffect} from 'react'
import {
	Button,
	Card,
	Col,
	Form,
	Input,
	Row,
	Select,
	Typography,
	Upload,
	Radio
} from "antd";

import data from '../../data/printingData'

const PrintSelector = (props) => {
    const {printingColors, printingType, printingSides, printingSpecialColors}  = data

    const handlePrintChange = (field, val) => {
        // Merge with existing printing state instead of resetting
        const current = { ...props.printing };
        current[field] = val;
        props.setPrinting(current);
    }
  return (
    <>
            <Card>
        <Form.Item
					style={{ marginBottom: "15px" }}
					name='printing_type'
					label='Printing Type'
					rules={[
						{
							required: true,
							message: "Please select printing type!",
						},
					]}>
					<Select
						name='printing_type'
						loading={!printingType}
						showSearch
						placeholder='Printing'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
                        onChange={(val) => handlePrintChange('printingType', val) }
						filterSort={(optionA, optionB) =>
							optionA.children
								.toLowerCase()
								.localeCompare(optionB.children.toLowerCase())
						}>
						{printingType &&
							printingType.map((printType, i) => (
								<Select.Option key={i+1} value={printType.value}>
									{printType.name}
								</Select.Option>
							))}
					</Select>
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					name='printing_colors'
					label='Printing Colours'
					rules={[
						{
							required: true,
							message: "Please select colours!",
						},
					]}>
					<Select
						name='printing_colors'
						loading={!printingColors}
						showSearch
						placeholder='No. of Colours'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						filterSort={(optionA, optionB) =>
							optionA.children
								.toLowerCase()
								.localeCompare(optionB.children.toLowerCase())
						}
                        onChange={(val) => handlePrintChange('printingColors', val) }
                        >
						{printingColors &&
							printingColors.map((colours, i) => (
								<Select.Option key={i+1} value={colours}>
									{colours}
								</Select.Option>
							))}
					</Select>
				</Form.Item>
                <Form.Item
					style={{ marginBottom: "15px" }}
					name='printing_sides'
					label='Printing Sides'
					rules={[
						{
							required: true,
							message: "Please select no of sides to be printed!",
						},
					]}>
					<Select
						name='printing_sides'
						loading={!printingSides}
						showSearch
						placeholder='No. of Sides'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						// filterSort={(optionA, optionB) =>
						// 	optionA.children
						// 		.toLowerCase()
						// 		.localeCompare(optionB.children.toLowerCase())
						// }
                        onChange={(val) => handlePrintChange('printingSides', val) }
                        >
						{printingSides &&
							printingSides.map((sides, i) => (
								<Select.Option key={i+1} value={sides}>
									{sides}
								</Select.Option>
							))}
					</Select>
				</Form.Item>
				<Form.Item
					style={{ marginBottom: "15px" }}
					name='printing_special_colors'
					label='Printing Special Colours'
					rules={[
						{
							required: false,
							message: "Please select special colours!",
						},
					]}>
					<Select
						name='printing_special_colors'
						loading={!printingSpecialColors}
						showSearch
						placeholder='No. of Special Colours'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						filterSort={(optionA, optionB) =>
							optionA.children
								.toLowerCase()
								.localeCompare(optionB.children.toLowerCase())
						}
                        onChange={(val) => handlePrintChange('printingSpecialColors', val) }
                        >
						{printingSpecialColors &&
							printingSpecialColors.map((colours, i) => (
								<Select.Option key={i+1} value={colours}>
									{colours}
								</Select.Option>
							))}
					</Select>
				</Form.Item>
             
            </Card>
    </>
  )
}

export default PrintSelector
